import { Meeting } from "./meeting";
import { Race } from "./race";
import { Entries, EntriesTable } from "./entries";

// general class for cms
export class PlainTextTable {
  headers?: string[];
  contents?: {
    byRow?: string[][];
    byCol?: {[colNo: number]: string[];};
  }
  
  constructor (value?: string) {
    const datas = value?.split("\r\n")?.map((r: string) => r.split("\t"))
    if (datas && datas.length) {
      this.headers = datas[0];
      if(datas.length > 1) {
        const byRow = (datas?.length || 0) > 1 ? datas?.slice(1, datas.length) : undefined;
        let byCol: { [colNo: number]: string[] } = {};
        byRow?.map((r: string[])=>
          r.map((d: string, idx: number)=>{
            if (!byCol[idx+1]) {
              byCol[idx+1] = [];
            }
            byCol[idx+1].push(d)
          })
        )
        this.contents = {byRow: byRow, byCol: byCol};
      }      
    }
  }
}

export {Meeting, Race, Entries, EntriesTable};